/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_ResubscribeInputs */

const fr_fancy_vast_otter_resubscribe = /** @type {(inputs: Fancy_Vast_Otter_ResubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous êtes sur le point de réactiver votre abonnement`)
};

/**

* @param {Fancy_Vast_Otter_ResubscribeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_resubscribe = /** @type {((inputs?: Fancy_Vast_Otter_ResubscribeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_ResubscribeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_resubscribe(inputs)
});